(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gl-desktop-human-card"] && !Shopify.designMode) return;
  try {
    (() => {
  function prepareHumanPreview() {
    const header = document.getElementById('shopify-section-header');
    const template = document.getElementById('gl-desktop-human-preview');
    if (!header || !template || header.dataset.glHumanPreviewReady) return;
    header.dataset.glHumanPreviewReady = 'true';
    let scheduled = false;
    const insert = () => {
      scheduled = false;
      if (!header.isConnected) { observer.disconnect(); return; }
      header.querySelectorAll('.horizontal-mega-menu > .buddha-menu-item > .mm-submenu.tabbed > li > a').forEach(link => {
        const panel = link.nextElementSibling;
        const path = new URL(link.href, document.baseURI).pathname.replace(/\/$/, '');
        if (path.endsWith('/collections/mensch-dna-test') && panel?.classList.contains('mm-submenu') && !panel.children.length) {
          panel.appendChild(template.content.cloneNode(true));
        }
      });
    };
    const observer = new MutationObserver(() => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(insert); }
    });
    observer.observe(header, {childList:true, subtree:true});
    insert();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareHumanPreview, {once:true});
  else prepareHumanPreview();
  document.addEventListener('shopify:section:load', prepareHumanPreview);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gl-dog-hero"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gl-dog-product')) {
  customElements.define('gl-dog-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('[data-gallery-track]');
      const slides = [...this.querySelectorAll('[data-gallery-slide]')];
      const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      const previous = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (track && slides.length > 1) {
        let active = 0;
        let frame = 0;
        const select = (index) => {
          const target = Math.max(0, Math.min(slides.length - 1, index));
          track.scrollTo({left: target * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        const sync = () => {
          active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
          thumbs.forEach((thumb, index) => {
            thumb.classList.toggle('is-active', index === active);
            if (index === active) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
          previous.disabled = active === 0;
          next.disabled = active === slides.length - 1;
        };
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => select(index)));
        previous.addEventListener('click', () => select(active - 1));
        next.addEventListener('click', () => select(active + 1));
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(sync);
        }, {passive: true});
        track.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            select(active + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        sync();
      }
      const form = this.querySelector('form');
      const button = this.querySelector('button[name="add"]');
      const sticky = this.querySelector('[data-sticky]');
      const stickyButton = this.querySelector('[data-sticky-add]');
      const stickyVariant = this.querySelector('[data-sticky-variant]');
      const stickyPrice = this.querySelector('[data-sticky-price]');
      const observer = new IntersectionObserver((entries) => {
        sticky.hidden = entries[0].isIntersecting;
      }, {threshold: 0});
      observer.observe(button);
      this.stickyObserver = observer;

      const update = (writeUrl) => {
        const selected = form.querySelector('input[name="id"]:checked');
        if (!selected) return;
        this.querySelector('[data-price]').textContent = selected.dataset.money;
        this.querySelectorAll('[data-variant-description]').forEach(node => { node.hidden = node.dataset.variantDescription !== selected.value; });
        button.disabled = selected.dataset.available !== 'true';
        stickyButton.disabled = button.disabled;
        stickyButton.textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        stickyPrice.textContent = selected.dataset.money;
        stickyVariant.textContent = selected.dataset.title;

        this.querySelector('[data-button-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.addLabel;
        if (writeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState(window.history.state, '', url);
        }
      };
      form.addEventListener('change', (event) => {
        if (event.target.matches('input[name="id"]')) update(true);
      });
      update(this.dataset.normalizeVariant === 'true');
    }
    disconnectedCallback() { if (this.stickyObserver) this.stickyObserver.disconnect(); this.initialized = false; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gl-dog-menu-priority"] && !Shopify.designMode) return;
  try {
    (() => {
  const priority = [
    'dna-hunderassenbestimmung',
    'futtermittel-check-hund',
    'dna-analyse-erbkrankheiten-hund',
    'allergietest-hund',
    'barf-check-hund',
    'mikronaehrstoff-check-hund',
    'mikrobiom-analyse-fur-hunde',
    'dna-wolfsanteil-analyse',
    'futtermittel-check-hund-welpen',
    'futtermittel-zusatzstoff-check-hund'
  ];
  function prepareDogOrder() {
    const header = document.getElementById('shopify-section-header');
    if (!header || header.dataset.glDogOrderReady) return;
    header.dataset.glDogOrderReady = 'true';
    let scheduled = false;
    const rank = item => {
      const link = item.querySelector(':scope > a');
      if (!link) return priority.length;
      const handle = new URL(link.href, document.baseURI).pathname.replace(/\/$/, '').split('/products/')[1];
      const index = priority.indexOf(handle);
      return index < 0 ? priority.length : index;
    };
    const sort = () => {
      scheduled = false;
      if (!header.isConnected) { observer.disconnect(); return; }
      header.querySelectorAll('.buddha-menu-item').forEach(item => {
        const link = item.querySelector(':scope > a');
        if (!link) return;
        const path = new URL(link.href, document.baseURI).pathname.replace(/\/$/, '');
        if (!/\/collections\/(liquid-check-hund|gesundheitscheck-hund)$/.test(path)) return;
        if (path.endsWith('/liquid-check-hund')) {
          const destination = path.replace(/liquid-check-hund$/, 'gesundheitscheck-hund');
          link.setAttribute('href', destination);
          link.setAttribute('data-href', destination);
        }
        const menu = item.querySelector(':scope > ul.mm-submenu');
        if (!menu) return;
        const current = Array.from(menu.children);
        const ordered = [...current].sort((a,b) => rank(a) - rank(b));
        ordered.forEach((child,index) => {
          if (menu.children[index] !== child) menu.insertBefore(child, menu.children[index]);
        });
      });
    };
    const observer = new MutationObserver(() => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(sort); }
    });
    observer.observe(header, {childList:true, subtree:true});
    sort();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareDogOrder, {once:true});
  else prepareDogOrder();
  document.addEventListener('shopify:section:load', prepareDogOrder);

  const directCartHandles = new Set([
    'dna-hunderassenbestimmung',
    'dna-analyse-erbkrankheiten-hund',
    'dna-wolfsanteil-analyse',
    'futtermittel-check-hund'
  ]);
  const baselines = new WeakMap();

  const productHandle = button => {
    const item = button.closest('li[item-type="featured-product"]');
    if (!item) return '';
    const links = item.querySelectorAll('a[href*="/products/"]');
    for (const link of links) {
      const path = new URL(link.href, document.baseURI).pathname.replace(/\/$/, '');
      const handle = path.split('/products/')[1]?.split('/')[0] || '';
      if (directCartHandles.has(handle)) return handle;
    }
    return '';
  };

  const cartSnapshot = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart.js?gl_direct=' + Date.now(), {
      credentials: 'same-origin',
      headers: {'Accept': 'application/json'},
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('cart');
    return response.json();
  };

  const quantityFor = (cart, handle) => (cart.items || []).reduce((sum, item) => {
    const itemHandle = item.handle || item.product_handle || '';
    return sum + (itemHandle === handle ? item.quantity : 0);
  }, 0);

  const prepareMenuDirectCart = () => {
    const header = document.getElementById('shopify-section-header');
    if (!header || header.dataset.glMenuDirectCartReady) return;
    header.dataset.glMenuDirectCartReady = 'true';

    header.addEventListener('pointerdown', event => {
      const button = event.target.closest('.mm-add-to-cart');
      if (!button || !header.contains(button)) return;
      const handle = productHandle(button);
      if (!handle) return;
      baselines.set(button, cartSnapshot().catch(() => null));
    }, true);

    header.addEventListener('click', async event => {
      const button = event.target.closest('.mm-add-to-cart');
      if (!button || !header.contains(button)) return;
      const handle = productHandle(button);
      if (!handle) return;

      const visibleCount = cart => (cart.items || []).reduce((sum, item) => {
        const hiddenPromo = item.properties && item.properties['_gl_promo_slot'] === '1';
        return sum + (hiddenPromo ? 0 : item.quantity);
      }, 0);
      const headerCount = parseInt(header.querySelector('[data-gl-cart-count]')?.textContent || '0', 10) || 0;
      const before = await (baselines.get(button) || cartSnapshot().catch(() => null));
      const beforeQuantity = before ? quantityFor(before, handle) : null;
      const beforeVisibleCount = before ? visibleCount(before) : headerCount;
      let attempts = 0;

      const check = async () => {
        attempts += 1;
        try {
          const current = await cartSnapshot();
          const targetIncreased = beforeQuantity !== null && quantityFor(current, handle) > beforeQuantity;
          const cartIncreased = visibleCount(current) > beforeVisibleCount;
          if (targetIncreased || cartIncreased) {
            const root = window.Shopify?.routes?.root || '/';
            window.location.assign(root + 'cart');
            return;
          }
        } catch (error) {}
        if (attempts < 50) window.setTimeout(check, 120);
      };

      window.setTimeout(check, 80);
    }, true);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareMenuDirectCart, {once:true});
  else prepareMenuDirectCart();
  document.addEventListener('shopify:section:load', prepareMenuDirectCart);
})();
  } catch(e) { console.error(e); }
})();

})();
